/**
 * Included into the footer of pages.
 */

import * as variables from './variables.js';

import './lib/AnimationEasing';

import "./lib/AnalyticsSetup"; 

import DetectBrowser from './lib/DetectBrowser';
DetectBrowser.addStyleClasses(document.documentElement);
const browserInfo = DetectBrowser.getInfo();

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);

import { MainMenu, CollapseExpandChildrenListener } from './component/MainMenu';

const animationUnsupported = browserInfo.android && browserInfo.android.browserVersion === 4.0;
new MainMenu({
	menu: '#menu',
	menuTriggerWrap: '.menuTrigger--open, .menuTrigger--close, .pageOverlay',
	nodeTrigger: '.menu-item-has-children > a',
	styleClass: {
		menuOpen: 'hasMenuOpen',
		nodeOpen: 'isOpen'
	},
	listeners: [
		new CollapseExpandChildrenListener(animationUnsupported ? 0 : 400, 'easeOutExpo')
	]
});

// Adds classes to body as we scroll
import Scrolled from './component/Scrolled';
new Scrolled({
	scrolledClass: 'hasScrolled',
	scrolledDistanceClass: 'hasScrolledDistance',
	scrollDistanceDown: 200,
	scrollDistanceUp: 20
});

import initInspiration from './component/Inspiration/Inspiration';
initInspiration();

// Animations
import InViewObserver from './component/InViewObserver';
InViewObserver.createInstance([
	{
		observeSelector: '.pageContent > .wp-block-group, .callToAction, .pageFooter__content',
		minimum: 20,
		minimumUnit: "px"
	},
	{
		observeSelector: '.decorativeShape__canvas, .pageFooter__donutCanvas',
		minimum: 50,
		minimumUnit: "%"
	}
]);

/* Redirect URLs containing "#" (Redirection plugin doesn't support this) */
const url = window.location.href;
if (url.endsWith('#welcome')) {
	window.location.replace(`${window.location.protocol}//${window.location.host}/about/`);
} else if (url.endsWith('#what-we-do')) {
	window.location.replace(`${window.location.protocol}//${window.location.host}/services/`);
} else if (url.endsWith('#portfolio')) {
	window.location.replace(`${window.location.protocol}//${window.location.host}/work/`);
} else if (url.endsWith('#meet-the-team')) {
	window.location.replace(`${window.location.protocol}//${window.location.host}/about/`);
}